import clientAuth from "../../clientAuth";

export default {
    // getSubscriberList:(currentPage, sortConfig)=> clientAuth.post(`admin/subscriptions/user/list?page=${currentPage}${sortConfig}`),
    getSubscriberList: (payload) =>
        clientAuth.post(`admin/subscriptions/user/list`, {
            json: payload,
        }),
    getSubscriptionList:()=> clientAuth.get(`subscription/subscription-list`),
    getSubscriptionPlanList:()=> clientAuth.get(`subscription/index`),
    getSubscriptionDataType:()=> clientAuth.get(`subscription/data-type-list`),
    subscribPaln: (userData) => clientAuth.post(`subscription/user-subscription`, { json: userData }),
    seat_upgrade: (userData) => clientAuth.post(`subscription/seat-upgrade`, { json: userData }),
    subscribCancel: (Id) => clientAuth.post(`subscription/cancel-subscription/${Id}`),
    getActiveSubscriptionPlan:()=> clientAuth.get(`subscription/active-subscription`),
    applyCoupon: (userData) => clientAuth.post(`admin/coupons/apply`, { json: userData }),
    destroy:(id) => clientAuth.post(`admin/subscriptions/delete-subscription/${id}`),
    updateSubscriptionDataType:(userData) => clientAuth.post(`admin/subscriptions/update-subscription-datatype`, { json: userData }),
};